<template>
    <!--
        Decal preview only. The 3D model viewer this component used to host was
        disabled long ago (Item3DView, behind the $f.Three flag), which left the
        render box permanently blank for every part that has a skn rather than a
        decal — so the box is no longer rendered for those at all. Part asset
        filenames now live in ItemPartAssets.vue, under the tech toggle.
    -->
    <div class="item-parts">
        <div class="content">
            <div class="render" ref="renderbox">
                <canvas class="render-surface" ref="render" :width=size.width :height=size.height></canvas>
            </div>
            <div class="overlay">
                <div class="part-select" v-if="showJobSelect">
                    <select v-model="selectedPartIndex">
                        <option v-for="(part, i) in sortedParts"
                            :key="i"
                            :value="i">{{ part.job.name.message }}</option>
                    </select>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import Vue from 'vue';
import Store from '@/store';
import { ApiHttpClient } from "@/globals";

// import Item3DView from "@/components/item/Item3DView.vue";
import { ensureRegion } from '@/api/RegionProvider';

export default {
    props: ["itemId", "parts", "type"],
    components: {
        // Item3DView,
    },
    data: function() {
        return {
            size: {
                width: 256,
                height: 256,
            },
            selectedPartIndex: 0,
        };
    },
    created() {
        this.init();
    },
    mounted() {
        this.setup();
    },
    computed: {
        sortedParts() {
            if (this.parts) {
                return this.parts.parts.sort((a, b) => a.clsid - b.clsid);
            } else {
                return [];
            }
        },
        selectedPart() {
            if (this.parts.parts.length != 0) {
                return this.parts.parts[this.selectedPartIndex];
            } else {
                return null;
            }
        },
        hasJobs() {
            if (this.parts.parts.length > 0) {
                return !!this.parts.parts[0].job;
            }
            return false;
        },
        showJobSelect() {
            return this.parts.parts.length > 1 && this.hasJobs;
        },
        isDecal() {
            return !!this.selectedPart.decalName;
        },
    },
    watch: {
        itemId(to, from) {
            if (to != from) {
                this.init();
            }
        },
        //  The job picker's only remaining job is choosing which decal to draw,
        //  so it has to actually redraw. (It never did before — the picker used
        //  to be shared with the asset-name overlay, which was reactive.)
        selectedPartIndex() {
            this.setup();
        },
    },
    methods: {
        init() {
        },
        activate() {
            this.active = true;
        },
        expand() {
            this.expanded = !this.expanded;
            Vue.nextTick().then(() => {
                if (this.expanded) {
                    const rect = this.$refs["renderbox"].getClientRects()[0];
                    this.size.width = Number(rect.width);
                    this.size.height = Number(rect.height);
                } else {
                    this.size.width = 256;
                    this.size.height = 256;
                }

                this.drawDecal();
            });
        },
        canvas() {
            return this.$refs["render"];
        },
        setup() {
            if (this.selectedPart.sknName) {

            } else if (this.selectedPart.decalName) {
                //  TEMPORARY
                this.drawDecal();
            }
        },
        drawDecal() {
            if (this.selectedPart.decalName) {
                let canvas = this.canvas();
                const region = ensureRegion(undefined, true);
                let url = `${ApiHttpClient.defaults.baseURL}/server/${region}/dds/${this.selectedPart.decalName}/png`;
                let img = new Image();
                img.addEventListener('load', () => {
                    let ctx = canvas.getContext('2d');
                    ctx.clearRect(0, 0, canvas.width, canvas.height);
                    ctx.drawImage(img, -128, 0, 512, 256);
                }, false);
                img.src = url;
            }
        }
    },
}
</script>
 
<style lang="less" scoped>
@import "../../less/core.less";

.item-parts {
    position: relative;
    width: 100%;
    height: 100%;
    background: transparent;

    .render {
        position: absolute;
        top: 0;
        left: 0;
        bottom: 0;
        right: 0;

        .render-surface {
            width: 100%;
            height: 100%;
            position: absolute;
            top: 0;
            .left(0);
        }
    }

    .overlay {
        z-index: 10;
        position: absolute;
        top: 0;
        left: 0;
        bottom: 0;
        right: 0;

        .part-select {
            position: absolute;
            bottom: 0;
            .left(0);
            .right(0);
            padding: 4px;
            text-align: center;
            background: fade(@dv-c-background, 80%);
        }
    }
}
</style>
 